import { createSelector } from 'reselect';
import isFeatureEnabled from './utils/isFeatureEnabled';
import { STUDENT, STAFF, EDUCATOR } from '$variables/constants';

const selectCoreBranch = (state) => state.core;

const selectStatusBranch = (state) => selectCoreBranch(state).status;
const getIsLoading = (state) => selectStatusBranch(state).isLoading;
const getError = (state) => selectStatusBranch(state).error;
const getAccessTokenInfo = (state, spaceId) =>
  selectCoreBranch(state).accessTokens[spaceId];
const getAccessToken = (state, spaceId) => {
  const tokenInfo = getAccessTokenInfo(state, spaceId);
  return tokenInfo ? tokenInfo.token : null;
};
const getCurrentSpace = (state) => selectCoreBranch(state).currentSpace;
const getCurrentSpaceId = (state) => getCurrentSpace(state).id;
const getSpaces = (state) => selectCoreBranch(state).spaces;
const getUser = (state) => selectCoreBranch(state).user;
const getUserId = (state) => getUser(state).id;
const getInstitution = (state) =>
  selectCoreBranch(state).institution.general.institution;

const getActiveSpaces = (state) => {
  const spaces = getSpaces(state);
  const currentSpace = getCurrentSpace(state);
  const activeSpaces = spaces
    .filter((space) => space.id !== currentSpace.id)
    .filter((space) => !space.isStaffOnly);

  return activeSpaces.sort((prev, next) => {
    const prevName = prev.name.toLowerCase();
    const nextName = next.name.toLowerCase();

    if (prevName < nextName) {
      return -1;
    }
    if (prevName > nextName) {
      return 1;
    }
    return 0;
  });
};

const getIsEducator = (state) => getCurrentSpace(state).isEducator;

const getViewAs = (state) => {
  const currentSpace = getCurrentSpace(state);
  if (!currentSpace) {
    return null;
  }

  if (currentSpace.isStaffOnly) {
    return STAFF;
  }

  return currentSpace.isEducator ? EDUCATOR : STUDENT;
};

const getFeatures = (state) => selectCoreBranch(state).institution.features;

const getIsManualAssignmentsEnabled = createSelector(getFeatures, (features) =>
  isFeatureEnabled(features, 'FEAT_ASSESSMENTS_MANUAL_ASSIGNMENT')
);

const getAllSpaceIds = (state) => {
  const { spaces } = selectCoreBranch(state);
  return spaces.map(({ id }) => id).join('|');
};

const getWSUrl = (state) => {
  const {
    general: { base_domain: baseDomain },
  } = selectCoreBranch(state).institution;
  return `https://services.${baseDomain}:44300/user`;
};

const getHasAwaitingDecision = createSelector(getFeatures, (features) =>
  isFeatureEnabled(features, 'FEAT_HAS_AWAITING_DECISION')
);

const getHasGradeOverride = createSelector(getFeatures, (features) =>
  isFeatureEnabled(features, 'FEAT_HAS_GRADE_OVERRIDE')
);

const getDisableGradePassBack = createSelector(getFeatures, (features) =>
  isFeatureEnabled(features, 'FEAT_DISABLE_GRADEPASSBACK')
);

export default {
  getDisableGradePassBack,
  getIsLoading,
  getError,
  getAccessTokenInfo,
  getAccessToken,
  getActiveSpaces,
  getCurrentSpace,
  getCurrentSpaceId,
  getUser,
  getUserId,
  getInstitution,
  getIsEducator,
  getViewAs,
  getIsManualAssignmentsEnabled,
  getAllSpaceIds,
  getWSUrl,
  getHasAwaitingDecision,
  getHasGradeOverride,
};
